import { useEffect, useState } from "react";

export default function AccessibilityToolbar() {
  const [open, setOpen] = useState(false);
  const [largeText, setLargeText] = useState(() => localStorage.getItem("fpb_large_text") === "1");
  const [highContrast, setHighContrast] = useState(() => localStorage.getItem("fpb_high_contrast") === "1");

  useEffect(() => {
    document.documentElement.classList.toggle("fpb-large-text", largeText);
    document.documentElement.classList.toggle("fpb-high-contrast", highContrast);
    localStorage.setItem("fpb_large_text", largeText ? "1" : "0");
    localStorage.setItem("fpb_high_contrast", highContrast ? "1" : "0");
  }, [largeText, highContrast]);

  return (
    <div className="fixed bottom-5 right-5 z-50 text-sm">
      <button
        type="button"
        onClick={() => setOpen((value) => !value)}
        aria-label="Open accessibility tools"
        className="rounded-full bg-slate-950 px-4 py-3 font-black text-white shadow-lg hover:bg-emerald-700"
      >
        A11y
      </button>

      {open && (
        <div className="mt-3 w-72 rounded-3xl bg-white p-4 shadow-2xl ring-1 ring-slate-200">
          <h2 className="font-black text-slate-950">Accessibility tools</h2>
          <p className="mt-1 text-xs text-slate-500">Improve readability and contrast while browsing.</p>

          <button
            type="button"
            onClick={() => setLargeText((value) => !value)}
            className="mt-4 w-full rounded-2xl border border-slate-200 px-4 py-3 text-left font-bold hover:bg-slate-50"
          >
            {largeText ? "✓" : "○"} Larger text
          </button>

          <button
            type="button"
            onClick={() => setHighContrast((value) => !value)}
            className="mt-2 w-full rounded-2xl border border-slate-200 px-4 py-3 text-left font-bold hover:bg-slate-50"
          >
            {highContrast ? "✓" : "○"} High contrast
          </button>

          <a href="#main-content" className="mt-2 block rounded-2xl border border-slate-200 px-4 py-3 font-bold text-emerald-700 hover:bg-emerald-50">
            Skip to main content
          </a>
        </div>
      )}
    </div>
  );
}
